import { render, staticRenderFns } from "./ReplacementReasons.vue?vue&type=template&id=b11c737a&"
import script from "./ReplacementReasons.vue?vue&type=script&lang=js&"
export * from "./ReplacementReasons.vue?vue&type=script&lang=js&"
import style0 from "./ReplacementReasons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1768404630/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b11c737a')) {
      api.createRecord('b11c737a', component.options)
    } else {
      api.reload('b11c737a', component.options)
    }
    module.hot.accept("./ReplacementReasons.vue?vue&type=template&id=b11c737a&", function () {
      api.rerender('b11c737a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/ReplacementWidget/ReplacementReasons.vue"
export default component.exports